import ReactSwitch from 'react-switch'
import { useTheme } from '../../hooks/useTheme'

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  'aria-label'?: string
  'aria-labelledby'?: string
  className?: string
}

/**
 * Theme-aware toggle switch using react-switch library.
 * Use inside SettingsToggleRow or standalone.
 * On-state uses Telegram `buttonColor` (blue accent), matching Quick Access selection.
 */
export function Switch({
  checked,
  onChange,
  disabled = false,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledby,
  className = '',
}: SwitchProps) {
  const theme = useTheme()

  const onColor = theme.buttonColor || '#0088cc'
  const offColor = theme.isDark ? '#3a3a3a' : '#e0e0e0'
  const handleColor = '#ffffff'

  return (
    <ReactSwitch
      checked={checked}
      onChange={(checkedValue) => onChange(checkedValue)}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      className={className}
      onColor={onColor}
      offColor={offColor}
      onHandleColor={handleColor}
      offHandleColor={handleColor}
      checkedIcon={false}
      uncheckedIcon={false}
      height={28}
      width={48}
      handleDiameter={22}
      activeBoxShadow={`0 0 0 2px ${onColor}40`}
    />
  )
}
